/**
 * Created by mnaughton on 12/3/2015.
 */

import SessionBase from "core/base/Session";
import User from "app/models/User";
import $ from "jquery";
import auth from "app/auth";
import RequestUtils from "app/utils/RequestUtils";
import _ from "underscore";
import modals from "core/views/modals";
import LoginView from "app/views/LoginView";
import urlService from "app/UrlService";
import messenger from "app/Messenger";
import sessionConfig from "app/session-config";
//todo import context

var Session = SessionBase.extend({
  initialize: async function () {
    var self = this;

    self.user = new User();
    self._userLoading = true;

    let config = await $.getJSON(location.origin + "/config.json");
    
    await auth.createClient(config.auth0);
    await auth.handleRedirect();

    // is there a user?
    if (!(await auth.isAuthenticated())) {
      auth.login();
    } else {
      urlService.initialize(config.apiRoot);
      self.user.url = urlService.apiurl("/currentuser");

      self._userLoading = false;
      let userAttributes = self.user.attributes;

      let currentUserData = await RequestUtils.get(self.user.url);

      _.each(currentUserData, function (value, key) {
        var existingAttribute = userAttributes[key];

        //If value has been returned from currentUser, and the existing user doesn't already hold an attribute.
        if (
          value &&
          (!existingAttribute ||
            (_.isArray(existingAttribute) && _.isEmpty(existingAttribute)))
        ) {
          userAttributes[key] = value;
        }
      });

      self.queryState();
    }

    this.whenAuthenticated(function () {
      self.registerTimeoutViews();
    });
  },

  isUserLoading: function () {
    return this._userLoading;
  },

  isAdmin: function () {
    return this.user.isAdmin();
  },

  getRoles: function () {
    return this.user.attributes.Permissions;
  },

  hasRole: function (role) {
    return this.user.hasRole(role);
  },

  hasAnyRole: function (role) {
    return this.user.hasAnyRole(role);
  },

  can: function (action, type) {
    return this.user.can(action, type);
  },

  /**
   * Gets the base url for the auth API. Does not have a trailing slash.
   * @return {String} The base URL for the auth API, containing protocol and hostname.
   */
  getBaseUrl: function () {
    return sessionConfig.getBaseUrl();
  },

  getAjaxLoginUrl: function () {
    return this.getBaseUrl() + "/logOn";
  },

  getAjaxLogoutUrl: function () {
    return "/auth/logOff";
  },

  //Calls the API to retrieve the current user
  //Passes in the X-Reload header, which refreshes the user cache.
  refreshCurrentUser: async function () {
    var self = this;

    if (self.user.url) {
      return $.ajax({
        url: self.user.url,
        headers: {
          Authorization: "Bearer " + auth.token,
          "X-Reload": true,
        },
      })
        .done(function (currentUserData) {
          self.user.attributes = currentUserData;
        })
        .fail(function (err) {
          console.log(err);
        });
    } else {
      return $.when();
    }
  },

  /**
   * Executes an AJAX login request. The URL is posted the credentials as JSON with "username" and "password" key.
   * @param  {string} token The authorization token.
   * @param  {object} [options]  An options hash.
   * @param {Boolean} options.trigger:true `true` if events shall be raised by this invocation, otherwise `false`.
   * @param {String} [options.url] The login URL to use. Default is `UrlService.apiurl('/auth/logOn')`.
   * @return {jqXHR}          An object representing the request.
   */
  loginWithRefreshToken: function (token, options) {
    var url = "/auth/refresh";
    var data = {
      token: token,
    };
    var self = this;

    return $.ajax({
      type: "POST",
      url: url,
      data: data,
      timeout: this.options.timeoutInterval,
    }).then(
      function (data) {
        if (data.error) {
          self._setState(
            SessionBase.CONNECTED,
            _.defaults({}, options, {
              error: {
                error: data.error,
              },
            })
          );
        } else {
          auth.setToken(data.token);
          self.trigger("login", data, options);

          return self.queryState(options);
        }
      },
      function (jqXHR) {
        if (jqXHR.status == 302) {
          return self.queryState(options);
        } else {
          self._responseError(jqXHR, options);
        }
      }
    );
  },

  /**
   * Executes the actual query request.
   * @param {object} options An options hash. This is the hash passed to `queryState`.
   * @param {object} [options.modalView] Pass in an optional modalView that will get removed upon successful execution
   * @return {Promise} A promise which rejects with an error and any options or resolves with the new session state and any options.
   */
  doQuery: function (options) {
    var modalView = options && options.modalView;
    var deferred = new $.Deferred();

    if (modalView) {
      modalView.remove();
    }

    if (!auth.expired() && !this._userLoading) {
      deferred.resolve(SessionBase.AUTHENTICATED, options);
    } else {
      deferred.resolve(SessionBase.CONNECTED, options);
    }

    return deferred.promise();
  },

  /**
   * Registers timeout views. This should maybe be done as a router at some point.
   * @protected
   */
  registerTimeoutViews: function () {
    var disconnectAlert, loginAlert, loginView;
    var session = this;

    function loginFunction(loginView) {
      return function () {
        if (loginAlert) {
          loginAlert.remove();
        }

        loginAlert = null;
        session.login(loginView.username, loginView.password);
      };
    }

    session.on("login", function (data) {
      auth.updateData(data);

      messenger.success("Your login was successful!");
    });

    session.on("disconnect", function () {
      if (!disconnectAlert) {
        disconnectAlert = modals.alert(
          "Disconnected",
          "We could not connect to a network. Please check your network connection and try again.",
          "Retry",
          function (modalView) {
            modalView.inProgress(true);
            session.queryState(null, modalView);
          },
          true,
          false
        );
      }
    });

    session.on("connect:error", function (err) {
      if (disconnectAlert) {
        disconnectAlert.remove();
      }

      var errorDetails = err.error
        ? "The error was: <strong>" + err.error + "</strong>"
        : "";

      disconnectAlert = modals.alert(
        "Connection Error",
        "An error occurred connecting to the network." +
          errorDetails +
          "</br> </br>Please check your network connection and try again.",
        "Retry",
        function (modalView) {
          modalView.inProgress(true);
          session.queryState(null, modalView);
        },
        true,
        false
      );
    });

    session.on("connect", async function () {
      if (disconnectAlert) {
        disconnectAlert.remove();
      }

      session.loginWithRefreshToken(auth.token);

      //we should go down to authenticate:error if there's an issue here, so the login prompt will still show up if this fails. hopefully.

      /*if(!loginAlert){
			 loginView = new LoginView({
			 message: 'Your session has timed out. Please log in again.',
			 context: context
			 });
			 loginView.render();
			 }

			 var login = loginFunction(loginView);

			 loginView.error = '';

			 if(!loginAlert) {
			 loginAlert = app.alert('Timed Out', loginView.$el, {
			 type: 'primary', text: 'Log In'
			 }, login, true);
			 loginView.$el.submit(function (evt) {
			 evt.preventDefault();
			 evt.returnValue = false;
			 loginView.remove();
			 loginAlert.remove();
			 loginAlert = null;
			 login();
			 });
			 }*/
    });

    session.on("authenticate:error", function (error) {
      if (disconnectAlert) {
        disconnectAlert.remove();
      }

      if (!loginAlert) {
        loginView = new LoginView({
          message: "Your session has timed out. Please log in again.",
        });
        loginView.render();
      }

      var login = loginFunction(loginView);

      if (error.error != "Forbidden") {
        loginView.error = error.error;
      }

      if (!loginAlert) {
        loginAlert = modals.alert(
          "Timed Out",
          loginView.$el,
          {
            type: "primary",
            text: "Log In",
          },
          login,
          true
        );
        loginView.$el.submit(function (evt) {
          evt.preventDefault();
          evt.returnValue = false;
          loginView.remove();
          loginAlert.remove();
          loginAlert = null;
          login();
        });
      }
    });

    session.on("authenticate:success", function () {
      if (disconnectAlert) {
        disconnectAlert.remove();
        messenger.success("Successfully reconnected!");
      }
    });
  },
});

export default new Session();



//////////////////
// WEBPACK FOOTER
// ./public/js/app/Session.js
// module id = 17
// module chunks = 1